<dx-pie-chart
  class="pie"
  palette="bright"
  [dataSource]="data">
  <dxo-title text="Olympic Medals in 2008">
    <dxo-font [weight]="300" [size]="18"></dxo-font>
  </dxo-title>
  <!--<dxo-adaptive-layout [height]="300" [width]="400"></dxo-adaptive-layout>-->
  <dxo-legend
    orientation="horizontal"
    itemTextPosition="right"
    horizontalAlignment="center"
    verticalAlignment="bottom"
    [columnCount]="4"></dxo-legend>
  <dxo-export [enabled]="false"></dxo-export>
  <dxi-series
    argumentField="country"
    valueField="medals">
    <dxo-label
      [visible]="true"
      [customizeText]="customizeLabel">
      <!--<dxo-font [size]="16"></dxo-font>-->
      <dxo-connector
        [visible]="true"
        [width]="0.5"></dxo-connector>
    </dxo-label>
  </dxi-series>
</dx-pie-chart>
